import * as React from 'react';
import styled, { StyledComponentClass } from 'styled-components';

/** @component */
export const StyledGridDiv = styled.div``;